<header>
  <div class="headline-section">
    <h2 class="dialog-title">
      <ng-content select="[comp-dialog-header-inner-title]"></ng-content>
    </h2>
    <div class="action-items">
      <ng-content select="[comp-dialog-header-inner-action-items]"></ng-content>
    </div>
    @if (showCloseIcon()) {
      <button comp-button="secondary" [iconOnly]="true" [mat-dialog-close]="closeIconValue()">
        <i
          comp-icon
          size="medium"
          class="ul-modal__close-icon"
          [mat-dialog-close]="closeIconValue()"
          >close</i
        >
      </button>
    }
  </div>
  <span class="dialog-subtitle">
    <ng-content select="[comp-dialog-header-inner-subtitle]"></ng-content>
  </span>
</header>
